import React from 'react';
import { useLocation } from 'react-use';

import ParallaxGrid from '../../molecules/ParallaxGrid';
import HeadingComponent from '../HeadingComponent/HeadingComponent';
import Card from '../Cards/Card';

import {
  Section,
  Wrapper,
  Heading,
  headingthemeMap,
  secondaryButtonVariantMap,
  Grid,
} from '../../styles/Components/CardDeck/CardDeck';

const CardDeck = ({ component }) => {
  const { pathname } = useLocation();

  const {
    backgroundColor,
    showParallaxGrid,
    headingAlignment,
    headingKicker,
    heading,
    subhead,
    primaryButton,
    secondaryButton,
    card,
  } = component;

  return (
    <Section
      backgroundColor={backgroundColor}
      id={pathname?.includes('pricing') ? 'add-ons' : 'card-deck'}
    >
      {showParallaxGrid && <ParallaxGrid theme="light" />}
      <Wrapper>
        <Heading>
          <HeadingComponent
            alignment={headingAlignment || 'center'}
            theme={headingthemeMap[backgroundColor]}
            headingKicker={headingKicker}
            heading={heading}
            subhead={subhead}
            primaryButton={primaryButton}
            primaryButtonVariant="Filled - Blue"
            secondaryButton={secondaryButton}
            secondaryButtonVariant={secondaryButtonVariantMap[backgroundColor]}
            primaryNextIcon="chevron-right"
          />
        </Heading>
        <Grid
          className="card-deck-grid"
          gridlayout={component?.gridLayout}
          cards={component?.card?.length}
        >
          {card?.map(c => (
            <Card key={c?.id} card={c} />
          ))}
        </Grid>
      </Wrapper>
    </Section>
  );
};

export default CardDeck;
